import { Card } from 'react-bootstrap';

const WhatsAppSettingsTabContent = ({
  activeSubTab,
  setActiveSubTab,
  renderBasicInfo,
  renderTemplateContent,
  renderSnippetsContent
}) => {
  const getTabStyle = (isActive, isDisabled = false) => ({
    backgroundColor: isActive ? '#FFFFFF' : 'transparent',
    color: isActive ? '#344054' : '#9CA8BB',
    border: 'none',
    borderRadius: '5px',
    padding: '5px 20px',
    fontWeight: isActive ? '600' : '400',
    fontSize: '16px',
    lineHeight: '1.5em',
    letterSpacing: '0.25%',
    fontFamily: 'Poppins',
    textAlign: 'center',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    margin: '0px',
    width: '120px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto'
  });

  return (
    <Card className="border-0" style={{
      backgroundColor: 'white',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      borderTopLeftRadius: '0px',
      borderTopRightRadius: '20px',
      borderBottomRightRadius: '20px',
      borderBottomLeftRadius: '20px',
      margin: '0 40px 40px 40px'
    }}>
      <Card.Body style={{ padding: '18px' }}>
        {/* Settings Sub-tabs */}
        <div style={{
          backgroundColor: '#ECEFF1',
          borderRadius: '10px',
          padding: '5px',
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          marginBottom: '20px',
          width: 'fit-content'
        }}>
          <div className="sub-navigation-tabs" style={{
            backgroundColor: 'transparent',
            gap: '0px',
            margin: '0',
            display: 'flex',
            alignItems: 'center'
          }}>
            <div className="nav-item" style={{marginBottom: 0}}>
              <button
                type="button"
                className="nav-link"
                onClick={() => setActiveSubTab('basic-info')}
                style={getTabStyle(activeSubTab === 'basic-info')}
              >
                Basic Info
              </button>
            </div>
            <div className="nav-item" style={{marginBottom: 0}}>
              <button
                type="button"
                className="nav-link"
                onClick={() => setActiveSubTab('template')}
                style={getTabStyle(activeSubTab === 'template')}
              >
                Template
              </button>
            </div>
            <div className="nav-item" style={{marginBottom: 0}}>
              <button
                type="button"
                className="nav-link"
                onClick={() => setActiveSubTab('snippets')}
                style={getTabStyle(activeSubTab === 'snippets')}
              >
                Snippets
              </button>
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div>
          {activeSubTab === 'basic-info' && (
            <div>
              {renderBasicInfo()}
            </div>
          )}
          {activeSubTab === 'template' && (
            <div style={{
              overflow: 'hidden'
            }}>
              {renderTemplateContent()}
            </div>
          )}
          {activeSubTab === 'snippets' && (
            <div>
              {renderSnippetsContent()}
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default WhatsAppSettingsTabContent;
